const IconArrowLeft = ({ className }) => {
    return (
        <svg
            width='32'
            height='32'
            viewBox='0 0 32 32'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <path d='M20 25.3333L10.6667 16L20 6.66667' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
    );
};

export default IconArrowLeft;
